import Vue from 'vue'
import http, { expandURI } from '@/utils/ajax'
import { INFORCECHART_INIT_LOADING, INFORCECHART_INIT_SUCCESS, INFORCECHART_INIT_FAIL } from '@/store/types'
import { extractMenu } from '@/utils/extract'

const state = {
  inforceChart: {
    init: 0,
    menu: {},
    lastUpdated: null,
    scope: null,
    appId: null,
    info: null,
    appIds: [],
    chartInfo: []
  }
}

const getters = {

}

const actions = {
  async initInforceChart({ commit, state }, data) {
    commit(INFORCECHART_INIT_LOADING)
    const apiUrl = state.permitWidgets.inforceChart
    if (apiUrl) {
      try {
        let params = {
          scope: data.scope,
          appId: data.appId
        }
        const result = await http.get(expandURI(apiUrl, params))
        const menu = extractMenu(result.data._links)

        Object.assign(data, {
          menu: menu,
          info: result.data.info,
          appIds: result.data.appIds,
          chartInfo: result.data.chartInfo
        })
        commit(INFORCECHART_INIT_SUCCESS, data)
      } catch (error) {
        commit(INFORCECHART_INIT_FAIL)
      }
    } else {
      commit(INFORCECHART_INIT_FAIL)
    }
  }
}

const mutations = {
  [INFORCECHART_INIT_LOADING](state) {
    state.inforceChart.init = 0
  },
  [INFORCECHART_INIT_SUCCESS](state, data) {
    const { inforceChart } = state
    inforceChart.menu = data.menu
    inforceChart.init = 1
    inforceChart.lastUpdated = new Date()
    inforceChart.scope = data.scope
    inforceChart.appId = data.appId
    inforceChart.info = data.info
    inforceChart.appIds = data.appIds
    Vue.set(inforceChart, 'chartInfo', data.chartInfo)
  },
  [INFORCECHART_INIT_FAIL](state) {
    state.inforceChart.init = 2
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
